/**
 * Header Layout
 *
 * @file header.js
 */

import $ from 'jquery';

const header = (() => {

  const fixedHeader = () => {
    var offset = $("header").offset();
     checkOffset();

     $(window).scroll(function() {
         checkOffset();
     });

     function checkOffset() {
         if ( $(window).scrollTop() >= 20){
             $('header').addClass('fixed_header');
         } else {
             $('header').removeClass('fixed_header');
         } 
     }
  };

  const fullMenu = () => {
    $(".header-menu .main-nav__item,.header-mt > .header-right .apply-now, .header-mt > .header-right .lang").hover(function(){
      $("header").addClass("show-menu");
    }, function(){
      $("header").removeClass("show-menu");
    })
  };

  const mobileMenu = () => {
    $(".mobile-menu-arrow").on("click", function(){
      $(this).toggleClass("active");
      $(".mobile-menu-toggle").toggleClass("active");
      $("body").toggleClass("hidden");
    });
  };

  const mobileDetailMenu = () => {
    window.addEventListener('load', function() {
      const banner = document.querySelector('.detail-banner');
      if(banner){
        
        if(banner.hasAttribute('mobile-banner')){
          // Eğer mobile-banner attribute'si varsa ve ekran genişliği 768px'den küçükse
          if (banner.hasAttribute('mobile-banner') && window.innerWidth <= 768) {
              const mobileBannerUrl = banner.getAttribute('mobile-banner');
              if (mobileBannerUrl) {
                  banner.style.backgroundImage = `url(${mobileBannerUrl})`;
              }
          }
        }
      }
    });
    
    // Ekran boyutu değiştiğinde yeniden kontrol et
    window.addEventListener('resize', function() {
      const banner = document.querySelector('.detail-banner');
      if(banner){
        
        if(banner.hasAttribute('mobile-banner')){
          // Eğer mobile-banner attribute'si varsa ve ekran genişliği 768px'den küçükse
          if (banner.hasAttribute('mobile-banner') && window.innerWidth <= 768) {
              const mobileBannerUrl = banner.getAttribute('mobile-banner');
              if (mobileBannerUrl) {
                  banner.style.backgroundImage = `url(${mobileBannerUrl})`;
              }
          }
        }
      }
    });
  };
  

  const init = () => {
    fixedHeader();
    fullMenu();
    mobileMenu();
    mobileDetailMenu();
  };

  return {
    init,
  };
})();

export default header;
